import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './guard'

export const router = createRouter({
  history: createWebHistory(),
  routes: [],
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => authGuard(to, next))

export default router
